export default __webpack_public_path__ + "static/media/pk.3f3d62b4.svg";